module.exports = __webpack_public_path__ + "img/harvesterlogo.a19e1243.png";